import { CurrencyValue, HugValue, NumberValue, PercentageValue, HashedNumberValue } from '@/components/tableElements';
import FlexRow from '@/components/FlexRow.vue';
import { mapState } from 'vuex';
import EvolutionValue from "@/components/tableElements/EvolutionValue.vue";
import SlotWithEvolutionValue from "@/components/tableElements/SlotWithEvolutionValue.vue";
import LiteTableMixin from "@/mixins/LiteTableMixin.vue";
export default {
  name: "PerformanceProductTableTotal",
  mixins: [LiteTableMixin],
  props: {
    fields: {
      type: Array,
      default: () => []
    },
    total: {
      type: Object,
      default: () => ({})
    },
    currencyConfig: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    },
    evolutionType: {
      type: String
    }
  },
  components: {
    CurrencyValue,
    HugValue,
    NumberValue,
    PercentageValue,
    FlexRow,
    EvolutionValue,
    SlotWithEvolutionValue,
    HashedNumberValue
  },
  data() {
    return {
      evolCategory: {
        prev_period: "_previous_period",
        same_period_ly: "_last_year"
      }
    };
  },
  computed: {
    ...mapState({
      periodCategory: state => state.market_insights.periodCategory,
      groupBy: state => state.market_insights.product_table.group_by_text
    })
  },
  methods: {
    isTotalColumn(field) {
      return ['category', 'seller_name', 'sales_channel', 'selector'].includes(field.key);
    },
    getJustify(field) {
      return ['avg_seller_price', 'avg_market_price', 'category_revenue_share'].includes(field.key) ? 'right' : 'left';
    },
    isStickyColumn(field) {
      return ['category', 'seller_name', 'sales_channel', 'selector', 'brand', 'competitor_seller_market_share_rank', 'category_revenue_share'].includes(field.key);
    },
    noBorderRight(field) {
      return ['category', 'selector', 'competitor_seller_market_share_rank'].includes(field.key);
    }
  }
};